/* Chalé — mobile carousel pagination dots.
   Auto-attaches dynamic dots under every .chale-cards carousel.
   Dots show only on mobile (CSS handles visibility); they track scroll
   position and scroll the carousel when tapped. */
(function () {
  function buildDots(track) {
    if (track.dataset.chaleDots === 'done') return;
    var cards = Array.prototype.filter.call(track.children, function (el) {
      return el.nodeType === 1;
    });
    if (cards.length < 2) return;
    track.dataset.chaleDots = 'done';

    var dots = document.createElement('div');
    dots.className = 'chale-dots is-on';
    dots.setAttribute('role', 'tablist');

    cards.forEach(function (card, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      if (i === 0) b.className = 'is-active';
      b.addEventListener('click', function () {
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    track.parentNode.insertBefore(dots, track.nextSibling);

    var buttons = dots.children;
    var raf = null;
    function sync() {
      raf = null;
      var center = track.scrollLeft + track.clientWidth / 2;
      var active = 0, best = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var mid = cards[i].offsetLeft + cards[i].clientWidth / 2 - track.offsetLeft;
        var d = Math.abs(mid - center);
        if (d < best) { best = d; active = i; }
      }
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].classList.toggle('is-active', j === active);
      }
    }
    track.addEventListener('scroll', function () {
      if (raf == null) raf = window.requestAnimationFrame(sync);
    }, { passive: true });
  }

  function init(root) {
    (root || document).querySelectorAll('.chale-cards').forEach(buildDots);
    initRecipeModals(root);
    initMarquees(root);
  }

  /* Seamless marquee: clone the sequence enough times to always exceed the
     viewport, animate by exactly one sequence width (set as a CSS var) at a
     constant px/sec speed. Recomputed on resize and after fonts load. */
  function setupMarquee(el) {
    var track = el.querySelector('.chale-marquee__track');
    if (!track) return;
    var seq = track.querySelector('.chale-marquee__seq');
    if (!seq) return;
    // drop previous clones, keep the original sequence
    track.querySelectorAll('.chale-marquee__seq[data-clone]').forEach(function (c) { c.remove(); });
    var seqWidth = seq.getBoundingClientRect().width;
    if (seqWidth < 2) return;
    var containerW = el.getBoundingClientRect().width;
    // enough copies so content always fills viewport behind the first sequence
    var copies = Math.ceil(containerW / seqWidth) + 1;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < copies; i++) {
      var clone = seq.cloneNode(true);
      clone.setAttribute('data-clone', '1');
      clone.setAttribute('aria-hidden', 'true');
      frag.appendChild(clone);
    }
    track.appendChild(frag);
    var speed = parseFloat(el.getAttribute('data-speed')) || 60; // px per second
    el.style.setProperty('--marq-seq-width', seqWidth + 'px');
    el.style.setProperty('--marq-dur', (seqWidth / speed) + 's');
    el.classList.add('is-ready');
  }
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-chale-marquee]').forEach(setupMarquee);
  }

  /* Recipe popup: clicking a .chale-rcard--modal clones its hidden
     <template> detail into the section's modal and opens it. */
  function initRecipeModals(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-rmodal]').forEach(function (modal) {
      if (modal.dataset.rmInit === '1') return;
      modal.dataset.rmInit = '1';
      var bodyEl = modal.querySelector('.chale-rmodal__body');
      modal.__close = function () {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (bodyEl) bodyEl.innerHTML = '';
        if (modal.__opener && modal.__opener.focus) modal.__opener.focus();
      };
      modal.__open = function (tpl, opener) {
        if (!bodyEl || !tpl) return;
        bodyEl.innerHTML = '';
        bodyEl.appendChild(tpl.content.cloneNode(true));
        modal.__opener = opener || null;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var c = modal.querySelector('.chale-rmodal__close');
        if (c) c.focus();
      };
      modal.querySelectorAll('[data-rmodal-close]').forEach(function (el) {
        el.addEventListener('click', modal.__close);
      });
    });

    scope.querySelectorAll('.chale-rcard--modal').forEach(function (card) {
      if (card.dataset.rmInit === '1') return;
      card.dataset.rmInit = '1';
      var host = card.closest('.chale') || document;
      var modal = host.querySelector('[data-rmodal]') || document.querySelector('[data-rmodal]');
      var tpl = card.querySelector('.chale-rcard__detail');
      if (!modal || !tpl) return;
      var go = function () { if (modal.__open) modal.__open(tpl, card); };
      card.addEventListener('click', go);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
      });
    });

    if (!document.__rmEsc) {
      document.__rmEsc = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-rmodal]:not([hidden])').forEach(function (m) {
          if (m.__close) m.__close();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Recompute marquees after web fonts load (width changes once Fraunces is ready)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { initMarquees(); });
  }
  // ...and on resize (debounced) so it stays seamless at any viewport width.
  var marqTimer = null;
  window.addEventListener('resize', function () {
    if (marqTimer) return;
    marqTimer = window.setTimeout(function () { marqTimer = null; initMarquees(); }, 200);
  });

  /* Keep the custom header cart count in sync with the Horizon cart drawer.
     The drawer re-renders its contents on every add/remove, so we watch it
     and re-fetch /cart.js whenever it mutates. */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.chale-cartcount').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }
  function watchCart() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.dataset.chaleWatch === 'on') return;
    drawer.dataset.chaleWatch = 'on';
    var t = null;
    var mo = new MutationObserver(function () {
      if (t) return;
      t = window.setTimeout(function () { t = null; refreshCartCount(); }, 250);
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }
})();
